import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { State } from 'reducers';
import { selectDeedById } from 'entities/deed/selectors';

import { DeedTypes } from './formUtils';

const mapDeedTypes: Record<string, DeedTypes> = {
  campaigns: 'Campaign',
  volunteer: 'Event',
  projects: 'Project',
  events: 'BaseEvent',
};

export const useDeedFormQueryParams = () => {
  const match = useRouteMatch<{ type: string; id: string }>();
  const deedId = match.params.id;
  const paramType = match.params.type;
  const deedType = mapDeedTypes[match.params.type] || 'Event';
  const deed = useSelector((state: State) => selectDeedById(state, deedId));
  const past = match.params.id === 'past' || (deed && deed.manual);

  return { deedId, paramType, deedType, deed, past };
};
